import { render, staticRenderFns } from "./RichScan.vue?vue&type=template&id=70ed0137&scoped=true&"
import script from "./RichScan.vue?vue&type=script&lang=js&"
export * from "./RichScan.vue?vue&type=script&lang=js&"
import style0 from "./RichScan.vue?vue&type=style&index=0&id=70ed0137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed0137",
  null
  
)

export default component.exports